import React, { useEffect, useState } from 'react';
import {
  ColumnGap,
  FilterClearButton,
  FilterContainer,
  FlexDirectionWrapper,
  MainContent,
  SubTitle,
  Text,
} from '../../../../../components/StyledComponents';
import { SearchInputAdmin } from '../../../../../components/SearchInputAdmin';
import { BaSeIcon } from '@base/react';
import { ExcelExportAdmin } from '../../../../../components/ExcelExportAdmin';
import { formatDateToBR } from '../../../../../utils/time';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { Grid } from '@mui/material';
import FiltersModel from '../../../filters.model';
import { formatStringArray, parseStringToJson, removeEmpty, sortByDirection } from '../../../../../utils/utils';
import axios from '../../../../../services/api';
import moment from 'moment';
import { TableAdmin } from '../../../../../components/TableAdmin';
import { handleModalAdmin } from '../../../../../utils/handleModalAdmin';
import { FilterSelectAdmin } from '../../../../../components/FilterSelectAdmin';
import { BlackListService } from '../../../services/blackListService';
import {
  cnpjMask,
  formatDefaultValueSelect,
  numberLocale,
} from '../../../../../utils/mask';

const tableColumns = [
  {
    field: 'ano',
    id: 'ano',
    label: 'Ano',
    minWidth: 10,
    handleField: (ano) => <>{ano ?? ''}</>,
  },
  {
    field: 'uf',
    id: 'uf',
    label: 'UF',
    align: 'left',
    minWidth: 10,
  },
  {
    field: 'cnpj',
    id: 'cnpj',
    label: 'CNPJ',
    align: 'left',
    minWidth: 135,
    handleField: cnpjMask,
  },
  {
    field: 'protocoloSas',
    id: 'protocoloSas',
    label: 'Protocolo_SAS',
    align: 'left',
    minWidth: 100,
  },
  {
    field: 'nomeAtendente',
    id: 'nomeAtendente',
    label: 'Nome Atendente',
    align: 'left',
    minWidth: 150,
    handleField: formatDefaultValueSelect,
  },
  {
    field: 'actions',
    id: 'actions',
    label: 'Status',
    minWidth: 10,
    align: 'left',
  },
];

export const GerenciarBlackList = () => {
  const {
    inputSearchValue,
    setInputSearchValue,
    filters,
    setFilters,
    paginationFilters,
    setPaginationFilters,
    handleOrderClick,
    onLinesPerPageChange,
    handlePageChange,
    handleInputPageChange,
    filterOptions,
    setFilterOptions,
    isLoading,
    setIsLoading,
    showModal,
  } = FiltersModel({
    orderBy: 'id',
  });

  const [data, setData] = useState([]);

  const getBodyParams = () => {
    return removeEmpty({ ...filters, oqueVoceProcura: inputSearchValue });
  };

  const getDataExcel = async () => {
    const source = axios.CancelToken.source();
    const bodyParams = getBodyParams();
    const pageFilter = { ...paginationFilters, page: 0, linesPerPage: 100000 };
    const response = await BlackListService.findAll(
      pageFilter,
      bodyParams,
      source
    );
    return response?.content?.map((r) => ({
      DATA: r?.data ? moment(r?.data).format('DD/MM/YYYY') : '',
      UF: r?.uf,
      CNPJ: cnpjMask(r?.cnpj),
      PROTOCOLO_SAS: r?.protocoloSas,
      NOME_ATENDENTE: r?.nomeAtendente,
    }));
  };
  //
  const getData = async () => {
    try {
      const bodyParams = getBodyParams();
      const response = await BlackListService.findAll(
        paginationFilters,
        bodyParams
      );
      setData(response);
    } catch (e) {
      console.log('erro =>>', e);
    } finally {
      setIsLoading(false);
    }
  };

  const getOptionsData = async () => {
    const response = await BlackListService.getFilterOptions();
    setFilterOptions(response);
  };

  useEffect(() => {
    getData();
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationFilters, filters, inputSearchValue]);

  useEffect(() => {
    getOptionsData();
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickClearFilters = async () => {
    setIsLoading(true);
    setData([]);
    setInputSearchValue(null);
    setFilters({});
    setPaginationFilters({
      page: 0,
      linesPerPage: 10,
      orderBy: 'data',
      direction: 'DESC',
    });
  };

  const handleDeleteClick = (id) => {
    handleModalAdmin({
      title: `Excluir`,
      content: `Você tem certeza que deseja excluir esse registro?`,
      msgOnSuccess: `Registro excluído com sucesso`,
      showAPIErrorIfAvailable: true,
      onFinish: () => {
        setIsLoading(true);
        setData([]);
        getData();
      },
      onConfirmClick: async () => await BlackListService.deleteById(id),
      showModal: showModal,
    });
  };

  const onChangeItemFilter = (event, field) => {
    setIsLoading(true);
    event.stopPropagation();
    const fieldValue = event.target.value
      ? JSON.parse(event.target.value)
      : event.target.value;
    setFilters({ ...filters, [field]: fieldValue });
  };

  const onChangeOrderByFilter = (targetValue) => {
    setIsLoading(true);
    const orderByParsed = parseStringToJson(targetValue);
    const { value } = orderByParsed;
    setIsLoading(true);
    switch (value) {
      case 'MAIS_RECENTES':
        setPaginationFilters((p) => ({
          ...p,
          orderBy: 'data',
          direction: 'DESC',
        }));
        break;
      case 'MAIS_ANTIGOS':
        setPaginationFilters((p) => ({
          ...p,
          orderBy: 'data',
          direction: 'ASC',
        }));
        break;
      case 'NOME':
        setPaginationFilters((p) => ({
          ...p,
          orderBy: 'nomeAtendente',
          direction: 'ASC',
        }));
        break;
      default:
        setPaginationFilters((p) => ({
          ...p,
          orderBy: 'id',
          direction: 'DESC',
        }));
    }
    setFilters((f) => ({ ...f, orderBy: orderByParsed }));
  };

  const orderByOptions = [
    {
      value: 'MAIS_RECENTES',
      label: 'Mais recentes',
    },
    {
      value: 'MAIS_ANTIGOS',
      label: 'Mais antigos',
    },
    {
      value: 'NOME',
      label: 'Nome (A-Z)',
    },
  ];

  // const getOrderUfFilters = filterOptions?.uf?.sort((a, b) => {
  //   return a?.sigla < b?.sigla ? -1 : a?.sigla > b?.sigla ? 1 : 0;
  // });

  const renderFilters = (color) => {
    return (
      <FilterContainer>
        <Accordion style={{ backgroundColor: '#F8F8F8', marginBottom: 20 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="accordion-filter"
            id="accordion-filter"
          >
            <BaSeIcon
              name="filter"
              color={color}
              size={25}
              description="Ícone de filtro"
            />
            <p style={{ color: color, fontWeight: 'bold' }}>Filtrar</p>
            <FilterClearButton
              color={color}
              onClick={(e) => {
                e.stopPropagation();
                onClickClearFilters();
              }}
            >
              <BaSeIcon
                name="close"
                size={10}
                color={color}
                description="Limpar filtros"
              />
              <p
                style={{
                  fontSize: '12px',
                  color: color,
                  borderBottom: `1px solid ${color}`,
                }}
              >
                Limpar filtros
              </p>
            </FilterClearButton>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2} conlumn={16}>
              {/* LEFT */}
              <Grid item container md={8} spacing={2}>
                <Grid item md={2}>
                  <FilterSelectAdmin
                    label="UF"
                    placeholder={'Selecione'}
                    // options={getOrderUfFilters}
                    options={sortByDirection(filterOptions?.uf)}
                    value={filters?.uf}
                    optionLabel={'sigla'}
                    onChangeItem={(event) => onChangeItemFilter(event, 'uf')}
                  />
                </Grid>

                <Grid item md={4}>
                  <FilterSelectAdmin
                    label="Nome do atendente"
                    placeholder={'Selecione'}
                    formatLabel={formatStringArray}
                    options={sortByDirection(filterOptions?.nomeAtendente)}
                    value={filters?.tipo}
                    onChangeItem={(event) =>
                      onChangeItemFilter(event, 'nomeAtendente')
                    }
                  />
                </Grid>
              </Grid>

              {/* RIGHT */}
              <Grid item container md justifyContent="end">
                <Grid item md={8}>
                  <FilterSelectAdmin
                    label="Ordernar Por"
                    labelColor="#0061C6"
                    placeholder={'Selecione'}
                    options={orderByOptions}
                    value={filters?.orderBy}
                    optionLabel={'label'}
                    returnAsObject
                    onChangeItem={(event) => {
                      onChangeOrderByFilter(event.target?.value);
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </FilterContainer>
    );
  };

  return (
    <MainContent>
      <SubTitle>
        <>
          <h3>Gerenciar</h3>
          <SearchInputAdmin
            value={inputSearchValue}
            onChange={setInputSearchValue}
          />
        </>
      </SubTitle>

      {renderFilters('#B3B3B3')}

      <FlexDirectionWrapper
        style={{ justifyContent: 'space-between', marginTop: '12px' }}
      >
        <ColumnGap gap="4px">
          <Text color="#0061C6" weight="bold">
            {numberLocale(data?.totalElements) ?? 0}
          </Text>
          <Text color="#B3B3B3">
            {data?.totalElements === 1 ? 'resultado' : 'resultados'} encontrados
          </Text>
        </ColumnGap>

        <ExcelExportAdmin
          filename={`Exportacao_BlackList_SSE_${formatDateToBR(new Date())}`}
          handleDataCallback={getDataExcel}
          isCsv
        />
      </FlexDirectionWrapper>

      <TableAdmin
        {...{
          data,
          paginationFilters,
          isLoading,
          onLinesPerPageChange,
          handleDeleteClick,
          handleOrderClick,
        }}
        sentEntireObjectToEdit
        sentEntireObjectToCopy
        columnAction={'actions'}
        linesPerPageFilters={paginationFilters?.linesPerPage}
        pagination={true}
        totalPages={data?.totalPages}
        columns={tableColumns}
        tableColor={'#0061C6'}
        lineColor={'rgba(0, 97, 198, 0.1)'}
        onPagePreviousChange={handlePageChange}
        onPageNextChange={handlePageChange}
        onInputPageChange={handleInputPageChange}
      />
    </MainContent>
  );
};
